





















import { defineComponent, PropType, ref } from '@vue/composition-api'

import { IParagraph } from '../../models/paragraph'

import scrollDirective from '@/shared/directives/scroll-directive'
import { bottomIsInParent } from '@/shared/filters/utils-filter'

import CloseButtonAtom from '@/shared/components/atoms/CloseButtonAtom.vue'
import RichTextAtom from '@/shared/components/atoms/RichTextAtom.vue'

export default defineComponent({
    name: "ContentComponent",
    components: {
        CloseButtonAtom,
        RichTextAtom
    },
    directives: {
        scrollDirective
    },
    props: {
        content: {
            type: Array as PropType<IParagraph[]>,
            required: true
        }
    },
    setup: (props) => {
        const paragraphs: String[] = props.content?.map(x => x.html)
        const contentElement = ref<HTMLElement | null>(null)?.value
        const showScrollIndicator: boolean = contentElement?.lastElementChild ?
            !bottomIsInParent(contentElement?.lastElementChild) :
            false

        return {
            contentElement,
            paragraphs,
            showScrollIndicator
        }
    }
})
